
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30950',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30950",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55527",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8466",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11920",
  "I18n": "static-7.1698",
  "quartz": "static-1.7601",
  "quartz-config": "static-1.1379",
  "quartz-core": "static-1.6820",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1050",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55514",
  "feedback-utils": "static-1.55518",
  "forms-embed-utils-lib": "static-1.4891",
  "forms-utils-lib": "static-1.13264",
  "foundations-assets": "static-1.5313",
  "foundations-components": "static-1.8676",
  "foundations-theming": "static-1.4911",
  "hub-http": "static-1.6637",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12227",
  "icons": "static-2.699",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4201",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17162",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5633",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.514",
  "tinymce-plugins": "static-1.58432",
  "transmute": "static-2.97",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8866",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3878",
  "quartz-webpack": "static-1.3825",
  "foundations-theming-specialty": "static-1.2627",
  "property-description-translator": "static-1.4248",
  "HeadJS": "static-2.816",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3577",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4736",
  "jasmine-runner": "static-1.6879",
  "opentelemetry-fe-types": "static-1.215",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.901",
  "hubspotter-http": "static-1.4941",
  "mobile-manifest-mixins": "static-1.599",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.590",
  "quartz-auth": "static-1.1276",
  "quartz-head": "static-1.1266",
  "quartz-i18n": "static-1.1276",
  "quartz-routing": "static-1.1031",
  "quartz-test": "static-1.1276",
  "quartz-tracking": "static-1.980",
  "trellis-components": "static-1-rdeane_hubspot-tooltip-trigger-canary.15",
  "ui-fonts": "static-1.1182",
  "usage-tracker-container": "static-1.7732",
  "usage-tracker-core": "static-1.7592",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.317",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8606",
  "sanitize-text": "static-1.8584",
  "PatternValidationJS": "static-1.3314",
  "ReduxMessenger": "static-2.10799",
  "outpost": "static-1.4561",
  "rpc-client-utils": "static-1.5098",
  "sanitize": "static-1.4901",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4945",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9852",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.95",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1-rdeane_hubspot-tooltip-trigger-canary.15",
  "bend-plugin-foundations-theming": "static-1.3394",
  "foundations-theming-base": "static-1.3896",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.371",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9943",
  "atom": "static-1.5505",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8356",
  "ContentUtils": "static-1.69371",
  "data-token-picker": "static-1.17057",
  "file-manager-components": "static-1.24760",
  "FileManagerCore": "static-1.40259",
  "FileManagerLib": "static-1.40400",
  "frontend-preferences-client": "static-1.8346",
  "hub-http-contrib": "static-1.3456",
  "interframe": "static-3.5168",
  "layout-dnd-components": "static-1.13147",
  "layout-dnd-utils": "static-1.12122",
  "property-translator": "static-1.5807",
  "react-codemirror": "static-1.11068",
  "react-colorpicker": "static-2.10640",
  "reference-resolvers-lite": "static-1.8534",
  "rich-text-lib": "static-1.20485",
  "tinymce-data": "static-1.41403",
  "tinymce-themes": "static-1.57288",
  "ui-addon-emoji-picker": "static-1.10294",
  "ui-addon-sales-email": "static-1.5630",
  "ui-brand-identity-lib": "static-1.16822",
  "bender-build-tools": "static-1.3518",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1414",
  "tanstack-virtual": "static-1.42",
  "stylex-utils": "static-1.165",
  "opentelemetry-web": "static-1.20",
  "beacon-keepalive-queue": "static-1.128",
  "hub-http-shared-msw-handlers": "static-1.10825",
  "hubspotter-http-shared-msw-handlers": "static-1.10823",
  "usage-tracker-session-replay": "static-1.5428",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.508",
  "chirp-fetch": "static-1.2329",
  "chatspot-core": "static-1.23571",
  "copilot-toolkit": "static-1.12066",
  "customer-data-objects-ui-components": "static-1.13458",
  "data-fetching-client": "static-1.10074",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5186",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29525",
  "usage-tracker": "static-1.7742",
  "cms-field-types": "static-1.5240",
  "content-icons-ui": "static-1.2418",
  "integrations-lib": "static-1.17322",
  "customer-data-objects": "static-1.8121",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2029",
  "apollo-link-hub-http": "static-2.5022",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4569",
  "poll-commands": "static-1.3902",
  "ui-addon-iframeable": "static-1.9504",
  "video-components-external": "static-1.12353",
  "video-data-lib": "static-1.36011",
  "breeze-artifacts-sdk": "static-1.723",
  "audio-components": "static-1.6505",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29991",
  "FileManagerImages": "static-1.37911",
  "foundations-components-legacy": "static-1.1701",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.685",
  "ui-universal-auth": "static-1.9641",
  "urlinator": "static-1.4944",
  "video-components": "static-1.14355",
  "video-embed": "static-1.36845",
  "ts-schema": "static-1.4371",
  "ContentData": "static-1.69446",
  "layout-data-lib": "static-1.10447",
  "react-dnd-compat": "static-1.5038",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1974",
  "external-options-client-types": "static-1.4420",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6017",
  "hs-resources": "static-1.625",
  "inbound-db-properties-service-client": "static-1.4118",
  "NamespacedHubStyle": "static-2.9334",
  "growth-onboarding-confetti": "static-1.3491",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11574",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5864",
  "magpie-types": "static-1.5324",
  "simple-logging-lib": "static-1.3480",
  "avatar-components": "static-1.2912",
  "customer-data-ui-utilities": "static-1.10261",
  "growth-onboarding-feedback-components": "static-1.7010",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5306",
  "integrations-error-boundary-lib": "static-1.14737",
  "integrations-tracking-lib": "static-1.6040",
  "laboratory-lib": "static-3.7578",
  "native-integrations-shared-strings": "static-1.8191",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10702",
  "unified-auth": "static-1.1155",
  "breeze-engine-chat-components": "static-1.1007",
  "breeze-engine-core": "static-1.1307",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1069",
  "navigation-messaging": "static-1.8409",
  "content-media-composition-data-lib": "static-1.13503",
  "content-media-compositions": "static-2.17510",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19573",
  "nudge-client-utils": "static-1.3339",
  "unified-auth-core-lib": "static-1.1437",
  "social-insights-client-types": "static-1.22860",
  "advanced-menus-core": "static-1.15744",
  "advanced-menus-lib": "static-1.12514",
  "ExportDialog": "static-6.10799",
  "ui-memberships-settings-lib": "static-1.35101",
  "conditional-properties-service-client": "static-1.4091",
  "crm-pipelines-api-client-types": "static-1.4422",
  "event-emitter": "static-1.1388",
  "framework-builder-read-service-client": "static-1.4301",
  "fdsr-migration-layer": "static-1.439",
  "inbound-db-meta-service-client": "static-1.3749",
  "multi-currency-client-types": "static-1.3987",
  "foundations-components-test-utils": "static-1.6159",
  "reactive-lib": "static-1.1151",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.765",
  "universal-page-editor-lib": "static-1.3437",
  "adobe-sign-auth-lib": "static-1.684",
  "ads-unified-auth-lib": "static-1.1799",
  "custom-vendor-connection-lib": "static-1.205",
  "google-sheets-integration-lib": "static-1.1252",
  "microsoft-drive-auth-lib": "static-1.412",
  "surveymonkey-integration-lib": "static-1.780",
  "slack-ui-library": "static-1.10825",
  "bend-plugin-pulse": "static-1.572",
  "fast-json-patch": "static-1.73",
  "nav-meta": "static-1.30719",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3096",
  "nudge-renderer-utils": "static-1.3415",
  "onboarding-tours": "static-1.17322",
  "whisper-core-api": "static-1.7561",
  "fsm": "static-1.4183",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15743",
  "simple-menus-lib": "static-1.17260",
  "settings-ui-lib": "static-1.12958",
  "persist-promise": "static-1.4131",
  "crm-record-cards-service-types": "static-1.3840",
  "framework-data-schema-resolvers": "static-1.7320",
  "location-customization-utils-lib": "static-1.10337",
  "getting-started-shared-tasks": "static-1.19483",
  "growth-data-modal": "static-1.6065",
  "growth-onboarding-next-action-utils": "static-1.2907",
  "navigation-components": "static-1.19082",
  "onboarding-tours-client": "static-1.5537",
  "onboarding-tours-utils": "static-1.1389",
  "ui-shepherd-tracker": "static-1.8083",
  "user-context": "static-1.5480",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7225",
  "onboarding-data-sync-lib": "static-1.2769",
  "growth-onboarding-next-action-components": "static-1.2935",
  "user-context-client": "static-1.4937",
  "nest": "static-1.664",
  "getting-started-shared-tasks-store": "static-1.18601",
  "InboxConnectUtils": "static-4.15768",
  "meetings-connect-utils-lib": "static-1.8044",
  "onboarding-scopes": "static-1.6880"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30950",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55527",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8466",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11920",
  "I18n": "/I18n/static-7.1698",
  "quartz": "/quartz/static-1.7601",
  "quartz-config": "/quartz-config/static-1.1379",
  "quartz-core": "/quartz-core/static-1.6820",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1050",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55514",
  "feedback-utils": "/feedback-utils/static-1.55518",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4891",
  "forms-utils-lib": "/forms-utils-lib/static-1.13264",
  "foundations-assets": "/foundations-assets/static-1.5313",
  "foundations-components": "/foundations-components/static-1.8676",
  "foundations-theming": "/foundations-theming/static-1.4911",
  "hub-http": "/hub-http/static-1.6637",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12227",
  "icons": "/icons/static-2.699",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4201",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17162",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5633",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "tinymce-plugins": "/tinymce-plugins/static-1.58432",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8866",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3878",
  "quartz-webpack": "/quartz-webpack/static-1.3825",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2627",
  "property-description-translator": "/property-description-translator/static-1.4248",
  "HeadJS": "/HeadJS/static-2.816",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3577",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4736",
  "jasmine-runner": "/jasmine-runner/static-1.6879",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.215",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.901",
  "hubspotter-http": "/hubspotter-http/static-1.4941",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.599",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.590",
  "quartz-auth": "/quartz-auth/static-1.1276",
  "quartz-head": "/quartz-head/static-1.1266",
  "quartz-i18n": "/quartz-i18n/static-1.1276",
  "quartz-routing": "/quartz-routing/static-1.1031",
  "quartz-test": "/quartz-test/static-1.1276",
  "quartz-tracking": "/quartz-tracking/static-1.980",
  "trellis-components": "/trellis-components/static-1-rdeane_hubspot-tooltip-trigger-canary.15",
  "ui-fonts": "/ui-fonts/static-1.1182",
  "usage-tracker-container": "/usage-tracker-container/static-1.7732",
  "usage-tracker-core": "/usage-tracker-core/static-1.7592",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.317",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8606",
  "sanitize-text": "/sanitize-text/static-1.8584",
  "PatternValidationJS": "/PatternValidationJS/static-1.3314",
  "ReduxMessenger": "/ReduxMessenger/static-2.10799",
  "outpost": "/outpost/static-1.4561",
  "rpc-client-utils": "/rpc-client-utils/static-1.5098",
  "sanitize": "/sanitize/static-1.4901",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4945",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9852",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.95",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1-rdeane_hubspot-tooltip-trigger-canary.15",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3394",
  "foundations-theming-base": "/foundations-theming-base/static-1.3896",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.371",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9943",
  "atom": "/atom/static-1.5505",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8356",
  "ContentUtils": "/ContentUtils/static-1.69371",
  "data-token-picker": "/data-token-picker/static-1.17057",
  "file-manager-components": "/file-manager-components/static-1.24760",
  "FileManagerCore": "/FileManagerCore/static-1.40259",
  "FileManagerLib": "/FileManagerLib/static-1.40400",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8346",
  "hub-http-contrib": "/hub-http-contrib/static-1.3456",
  "interframe": "/interframe/static-3.5168",
  "layout-dnd-components": "/layout-dnd-components/static-1.13147",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12122",
  "property-translator": "/property-translator/static-1.5807",
  "react-codemirror": "/react-codemirror/static-1.11068",
  "react-colorpicker": "/react-colorpicker/static-2.10640",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8534",
  "rich-text-lib": "/rich-text-lib/static-1.20485",
  "tinymce-data": "/tinymce-data/static-1.41403",
  "tinymce-themes": "/tinymce-themes/static-1.57288",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10294",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5630",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16822",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1414",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "stylex-utils": "/stylex-utils/static-1.165",
  "opentelemetry-web": "/opentelemetry-web/static-1.20",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.128",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10825",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10823",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5428",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.508",
  "chirp-fetch": "/chirp-fetch/static-1.2329",
  "chatspot-core": "/chatspot-core/static-1.23571",
  "copilot-toolkit": "/copilot-toolkit/static-1.12066",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13458",
  "data-fetching-client": "/data-fetching-client/static-1.10074",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5186",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29525",
  "usage-tracker": "/usage-tracker/static-1.7742",
  "cms-field-types": "/cms-field-types/static-1.5240",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "integrations-lib": "/integrations-lib/static-1.17322",
  "customer-data-objects": "/customer-data-objects/static-1.8121",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2029",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4569",
  "poll-commands": "/poll-commands/static-1.3902",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9504",
  "video-components-external": "/video-components-external/static-1.12353",
  "video-data-lib": "/video-data-lib/static-1.36011",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.723",
  "audio-components": "/audio-components/static-1.6505",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29991",
  "FileManagerImages": "/FileManagerImages/static-1.37911",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1701",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.685",
  "ui-universal-auth": "/ui-universal-auth/static-1.9641",
  "urlinator": "/urlinator/static-1.4944",
  "video-components": "/video-components/static-1.14355",
  "video-embed": "/video-embed/static-1.36845",
  "ts-schema": "/ts-schema/static-1.4371",
  "ContentData": "/ContentData/static-1.69446",
  "layout-data-lib": "/layout-data-lib/static-1.10447",
  "react-dnd-compat": "/react-dnd-compat/static-1.5038",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1974",
  "external-options-client-types": "/external-options-client-types/static-1.4420",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6017",
  "hs-resources": "/hs-resources/static-1.625",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4118",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9334",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3491",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11574",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5864",
  "magpie-types": "/magpie-types/static-1.5324",
  "simple-logging-lib": "/simple-logging-lib/static-1.3480",
  "avatar-components": "/avatar-components/static-1.2912",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10261",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7010",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5306",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14737",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6040",
  "laboratory-lib": "/laboratory-lib/static-3.7578",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8191",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10702",
  "unified-auth": "/unified-auth/static-1.1155",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1007",
  "breeze-engine-core": "/breeze-engine-core/static-1.1307",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1069",
  "navigation-messaging": "/navigation-messaging/static-1.8409",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13503",
  "content-media-compositions": "/content-media-compositions/static-2.17510",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19573",
  "nudge-client-utils": "/nudge-client-utils/static-1.3339",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1437",
  "social-insights-client-types": "/social-insights-client-types/static-1.22860",
  "advanced-menus-core": "/advanced-menus-core/static-1.15744",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12514",
  "ExportDialog": "/ExportDialog/static-6.10799",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35101",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4091",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4422",
  "event-emitter": "/event-emitter/static-1.1388",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4301",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.439",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3749",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3987",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6159",
  "reactive-lib": "/reactive-lib/static-1.1151",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.765",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3437",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.684",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1799",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.205",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1252",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.412",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.780",
  "slack-ui-library": "/slack-ui-library/static-1.10825",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.572",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "nav-meta": "/nav-meta/static-1.30719",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3096",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3415",
  "onboarding-tours": "/onboarding-tours/static-1.17322",
  "whisper-core-api": "/whisper-core-api/static-1.7561",
  "fsm": "/fsm/static-1.4183",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15743",
  "simple-menus-lib": "/simple-menus-lib/static-1.17260",
  "settings-ui-lib": "/settings-ui-lib/static-1.12958",
  "persist-promise": "/persist-promise/static-1.4131",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3840",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7320",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10337",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19483",
  "growth-data-modal": "/growth-data-modal/static-1.6065",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2907",
  "navigation-components": "/navigation-components/static-1.19082",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5537",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1389",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8083",
  "user-context": "/user-context/static-1.5480",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7225",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2769",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2935",
  "user-context-client": "/user-context-client/static-1.4937",
  "nest": "/nest/static-1.664",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18601",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15768",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8044",
  "onboarding-scopes": "/onboarding-scopes/static-1.6880"
}
};
